<template>
  <el-table border :data="tableData" height="600px" style="width: 100%">
    <el-table-column prop="id" label="ID" width="180"></el-table-column>
    <el-table-column prop="mediaAssetId" label="乐播媒资ID" width="180"></el-table-column>
    <el-table-column show-overflow-tooltip prop="title" label="内容标题"></el-table-column>
    <el-table-column prop="coverImg" label="内容图片" width="150">
      <template slot-scope="scope">
        <el-image
          style="height: 50px"
          :src="scope.row.coverImg"
          :preview-src-list="[scope.row.coverImg]"
          fit="scale-down"
          @click.stop="clickImg"
        ></el-image>
      </template>
    </el-table-column>
    <el-table-column prop="partnerName" label="媒资来源"></el-table-column>
    <el-table-column prop="tags" label="宣传标签"></el-table-column>
    <el-table-column prop="status" label="状态">
      <template slot-scope="scope">
        <!-- 增加待上架 -->
        <!-- 0：失效；1：生效；2：待生效） -->
        <span v-if="scope.row.status === 0">下架</span>
        <span v-else-if="scope.row.status === 1">上架</span>
        <span v-else-if="scope.row.status === 2">待上架</span>
      </template>
    </el-table-column>
    <el-table-column prop="createTime" label="创建时间"></el-table-column>
    <!-- 上架时间 -->
    <el-table-column prop="effectStartTime" label="上架时间">
      <template slot-scope="scope">
        <!-- - 【新增】“上架时段”列表字段，下架时不显示，上架时显示指定时间或时段 -->
        <span v-if="scope.row.status !== 0 && scope.row.effectStartTime && scope.row.effectEndTime">{{ scope.row.effectStartTime }} 至 {{ scope.row.effectEndTime
          }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="remark" label="备注"></el-table-column>
    <el-table-column fixed="right" label="操作" width="120">
      <template slot-scope="scope">
        <el-button v-auth="'LIST_CONTENT_MANAGE_LOG'" @click="viewLog(scope.row)" type="text"
                   size="small">日志</el-button>
        <el-button v-auth="'LIST_CONTENT_MANAGE_EDIT'" @click="edit(scope.row)" type="text"
                   size="small">编辑</el-button>
        <el-button v-auth="'LIST_CONTENT_MANAGE_DEL'" @click="del(scope.row)" type="text"
                   size="small">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: 'mediaTable',
    props: {
      tableData: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data () {
      return {
      }
    },
    methods: {
      clickImg() {
        this.$emit('clickImg')
      },
      edit(row) {
        this.$emit('edit', row)
      },
      viewLog(row) {
        this.$emit('viewLog', row)
      },
      del(row) {
        this.$emit('del', row)
      },
    }
  }
</script>
<style lang="scss" scoped>
</style>
